import React from 'react';

function Bproperty(props) {
    return (
        <div className='p-box'>
            <img src={props.image} alt=""/>
            <p></p>
            <div className='name'>{props.name}</div>
            <a href='#' className='price'>{props.price}</a>
            <a href='#' className='buy-btn'>Add to Cart&nbsp;<i class="fas fa-cart-arrow-down"></i></a>
        </div>
    );
}
export default Bproperty;
